import {
  VStack,
  Button,
  Icon,
  SimpleGrid,
  Box,
  Text,
  Card,
  CardBody,
  Heading,
  Flex,
  Center,
  Spacer,
} from "@chakra-ui/react";
import UserDataHome from "../components/user-data-home";
import Footer from "../components/footer";
import { useNavigate } from "react-router-dom";
import { RiCustomerService2Fill } from "react-icons/ri";
import { useAppContext } from "../context/AppContext";
import { useEffect } from "react";
import { TbZoomMoney } from "react-icons/tb";
import { FaCog, FaHistory, FaTruck } from "react-icons/fa";

const HomePage = () => {
  const { username } = useAppContext();
  const { password } = useAppContext();
  const navigate = useNavigate();

  // Verificar autenticação dentro de useEffect para evitar redirecionamentos durante render
  useEffect(() => {
    if (username === "" || password === "") {
      navigate("/error");
    }
  }, [username, password, navigate]);

  return (
    <Flex direction="column" minHeight="100vh" bg="gray.50">
      <UserDataHome />
      <Box flex="1" py={{ base: 4, md: 8 }}>
        <Box
          maxW={{ base: "100%", lg: "1200px" }}
          mx="auto"
          px={{ base: 4, md: 6 }}
          mt={{ base: 6, md: 8 }}
        >
          <SimpleGrid
            columns={{ base: 1, sm: 2, lg: 3 }}
            spacing={{ base: 6, md: 8 }}
            maxW="1200px"
            mx="auto"
            alignItems="stretch"
          >
            {/* Card Simulação de Custo */}
            <Box as="div" h="100%" minH="280px" display="flex">
              <Card
                bg="white"
                borderRadius="xl"
                boxShadow="md"
                border="1px solid"
                borderColor="gray.200"
                _hover={{
                  transform: "translateY(-8px)",
                  boxShadow: "xl",
                  borderColor: "#007abe",
                }}
                transition="all 0.3s"
                cursor="pointer"
                onClick={() => navigate("/simulacao-custos")}
                flex="1"
                minH="0"
                display="flex"
                flexDirection="column"
              >
                <CardBody p={8} flex="1" display="flex" flexDirection="column">
                  <VStack
                    spacing={6}
                    align="stretch"
                    flex="1"
                    minH={0}
                    display="flex"
                    flexDirection="column"
                  >
                    <Center flexShrink={0}>
                      <Box
                        bg="#007abe"
                        borderRadius="full"
                        p={6}
                        boxShadow="lg"
                      >
                        <Icon as={TbZoomMoney} boxSize={12} color="#c0a316" />
                      </Box>
                    </Center>
                    <VStack spacing={2}>
                      <Heading
                        size="lg"
                        color="#007abe"
                        fontWeight="bold"
                        textAlign="center"
                      >
                        Simulação de Custo
                      </Heading>
                      <Text color="gray.600" textAlign="center" fontSize="sm">
                        Calcule e simule custos de transporte
                      </Text>
                    </VStack>
                    <Spacer />
                    <Button
                      bg="#007abe"
                      color="white"
                      size="lg"
                      width="100%"
                      _hover={{
                        bg: "#0066a3",
                        transform: "scale(1.02)",
                      }}
                      transition="all 0.2s"
                    >
                      Acessar
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            </Box>

            {/* Card Realizar Atendimento */}
            <Box as="div" h="100%" minH="280px" display="flex">
              <Card
                bg="white"
                borderRadius="xl"
                boxShadow="md"
                border="1px solid"
                borderColor="gray.200"
                _hover={{
                  transform: "translateY(-8px)",
                  boxShadow: "xl",
                  borderColor: "#007abe",
                }}
                transition="all 0.3s"
                cursor="pointer"
                onClick={() => navigate("/atendimento")}
                flex="1"
                minH="0"
                display="flex"
                flexDirection="column"
              >
                <CardBody p={8} flex="1" display="flex" flexDirection="column">
                  <VStack
                    spacing={6}
                    align="stretch"
                    flex="1"
                    minH={0}
                    display="flex"
                    flexDirection="column"
                  >
                    <Center flexShrink={0}>
                      <Box
                        bg="#007abe"
                        borderRadius="full"
                        p={6}
                        boxShadow="lg"
                      >
                        <Icon
                          as={RiCustomerService2Fill}
                          boxSize={12}
                          color="#c0a316"
                        />
                      </Box>
                    </Center>
                    <VStack spacing={2}>
                      <Heading
                        size="lg"
                        color="#007abe"
                        fontWeight="bold"
                        textAlign="center"
                      >
                        Atendimento
                      </Heading>
                      <Text color="gray.600" textAlign="center" fontSize="sm">
                        Inicie um novo atendimento ao cliente
                      </Text>
                    </VStack>
                    <Spacer />
                    <Button
                      bg="#007abe"
                      color="white"
                      size="lg"
                      width="100%"
                      _hover={{
                        bg: "#0066a3",
                        transform: "scale(1.02)",
                      }}
                      transition="all 0.2s"
                    >
                      Acessar
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            </Box>

            {/* Card Configuração (Frota, Motoristas, Produtos, Fornecedores) */}
            <Box as="div" h="100%" minH="280px" display="flex">
              <Card
                bg="white"
                borderRadius="xl"
                boxShadow="md"
                border="1px solid"
                borderColor="gray.200"
                _hover={{
                  transform: "translateY(-8px)",
                  boxShadow: "xl",
                  borderColor: "#007abe",
                }}
                transition="all 0.3s"
                cursor="pointer"
                onClick={() => navigate("/configuracao")}
                flex="1"
                minH="0"
                display="flex"
                flexDirection="column"
              >
                <CardBody p={8} flex="1" display="flex" flexDirection="column">
                  <VStack
                    spacing={6}
                    align="stretch"
                    flex="1"
                    minH={0}
                    display="flex"
                    flexDirection="column"
                  >
                    <Center flexShrink={0}>
                      <Box
                        bg="#007abe"
                        borderRadius="full"
                        p={6}
                        boxShadow="lg"
                      >
                        <Icon as={FaCog} boxSize={12} color="#c0a316" />
                      </Box>
                    </Center>
                    <VStack spacing={2}>
                      <Heading
                        size="lg"
                        color="#007abe"
                        fontWeight="bold"
                        textAlign="center"
                      >
                        Configuração
                      </Heading>
                      <Text color="gray.600" textAlign="center" fontSize="sm">
                        Frota, motoristas, produtos e fornecedores
                      </Text>
                    </VStack>
                    <Spacer />
                    <Button
                      bg="#007abe"
                      color="white"
                      size="lg"
                      width="100%"
                      _hover={{ bg: "#0066a3", transform: "scale(1.02)" }}
                      transition="all 0.2s"
                    >
                      Acessar
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            </Box>

            {/* Card Histórico de Preços */}
            <Box as="div" h="100%" minH="280px" display="flex">
              <Card
                bg="white"
                borderRadius="xl"
                boxShadow="md"
                border="1px solid"
                borderColor="gray.200"
                _hover={{
                  transform: "translateY(-8px)",
                  boxShadow: "xl",
                  borderColor: "#007abe",
                }}
                transition="all 0.3s"
                cursor="pointer"
                onClick={() => navigate("/historico-precos")}
                flex="1"
                minH="0"
                display="flex"
                flexDirection="column"
              >
                <CardBody p={8} flex="1" display="flex" flexDirection="column">
                  <VStack
                    spacing={6}
                    align="stretch"
                    flex="1"
                    minH={0}
                    display="flex"
                    flexDirection="column"
                  >
                    <Center flexShrink={0}>
                      <Box
                        bg="#007abe"
                        borderRadius="full"
                        p={6}
                        boxShadow="lg"
                      >
                        <Icon as={FaHistory} boxSize={12} color="#c0a316" />
                      </Box>
                    </Center>
                    <VStack spacing={2}>
                      <Heading
                        size="lg"
                        color="#007abe"
                        fontWeight="bold"
                        textAlign="center"
                      >
                        Histórico de Preços
                      </Heading>
                      <Text color="gray.600" textAlign="center" fontSize="sm">
                        Preços por fornecedor, produto e data
                      </Text>
                    </VStack>
                    <Spacer />
                    <Button
                      bg="#007abe"
                      color="white"
                      size="lg"
                      width="100%"
                      _hover={{ bg: "#0066a3", transform: "scale(1.02)" }}
                      transition="all 0.2s"
                    >
                      Acessar
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            </Box>

            {/* Card Ordem de Carregamento */}
            <Box as="div" h="100%" minH="280px" display="flex">
              <Card
                bg="white"
                borderRadius="xl"
                boxShadow="md"
                border="1px solid"
                borderColor="gray.200"
                _hover={{
                  transform: "translateY(-8px)",
                  boxShadow: "xl",
                  borderColor: "#007abe",
                }}
                transition="all 0.3s"
                cursor="pointer"
                onClick={() => navigate("/ordem-carregamento")}
                flex="1"
                minH="0"
                display="flex"
                flexDirection="column"
              >
                <CardBody p={8} flex="1" display="flex" flexDirection="column">
                  <VStack
                    spacing={6}
                    align="stretch"
                    flex="1"
                    minH={0}
                    display="flex"
                    flexDirection="column"
                  >
                    <Center flexShrink={0}>
                      <Box
                        bg="#007abe"
                        borderRadius="full"
                        p={6}
                        boxShadow="lg"
                      >
                        <Icon as={FaTruck} boxSize={12} color="#c0a316" />
                      </Box>
                    </Center>
                    <VStack spacing={2}>
                      <Heading
                        size="lg"
                        color="#007abe"
                        fontWeight="bold"
                        textAlign="center"
                      >
                        Ordem de Carregamento
                      </Heading>
                      <Text color="gray.600" textAlign="center" fontSize="sm">
                        Lance frota, motorista, volume e compartimentos
                      </Text>
                    </VStack>
                    <Spacer />
                    <Button
                      bg="#007abe"
                      color="white"
                      size="lg"
                      width="100%"
                      _hover={{ bg: "#0066a3", transform: "scale(1.02)" }}
                      transition="all 0.2s"
                    >
                      Acessar
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            </Box>
          </SimpleGrid>
        </Box>
      </Box>
      <Footer />
    </Flex>
  );
};

export default HomePage;
